const Pieces = {
  BLACK_MOAI: "black",
  WHITE_MOAI: "white",
};

export default Pieces;
